import { useContext, useEffect, useState, useRef, useMemo } from "react";
import { TransaccionalContext } from "./Transaccional";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { FloatLabel } from "primereact/floatlabel";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import '../../components/estilo.css';
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../../components/InputComponent";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Toolbar } from "primereact/toolbar";
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import { ConfirmDialogPersonalizado } from "../../components/ConfirmDialogPersonalizado";
import { Divider } from "primereact/divider";
import { RadioButton } from "primereact/radiobutton";
import { ProgressSpinner } from "primereact/progressspinner";
import { Menu } from "primereact/menu";
import { ChartPersonalizado } from "../../components/ChartPersonalizado";
import { ToggleButton } from "primereact/togglebutton";
import { useToken } from "../../components/useToken";
import { MatrizTransaccional } from "../../models/monitoreo/MatrizTransaccional";
import { Transaccion } from "../../models/monitoreo/Transaccion";
import { Paginator } from "primereact/paginator";
import { Calendar } from "primereact/calendar";
import { useForm } from "react-hook-form";
import { TablaTransaccional as TablaTransaccionalClass } from "../../models/monitoreo/TablaTransaccional";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useAlertas } from "../../context/AlertasContext";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export const TablaTransaccional = ({ tablaTemporal, matriz, permss, funcionalidades, toast, generic, handleCloseTabla }) => {

    const TablaTransaccionModel = useMemo(() => { return new TablaTransaccionalClass(tablaTemporal); }, [tablaTemporal]);
    const tablaEstado = useLazyParams({ modelo: TablaTransaccionModel.model });
    const omodel = new MatrizTransaccional();
    const transaccionModel = new Transaccion();
    const { setError } = useForm();
    const [loadingFormulario, setLoadingFormulario] = useState(false);
    const [loadingToolbar, setLoadingToolbar] = useState(true);
    const [loadExcel, setLoadExcel] = useState(false);
    const [loadPdf, setLoadPdf] = useState(false);
    const monitoreoService = new MonitoreoService();
    const [showDialog, setShowDialog] = useState(false);
    const [nombre, setNombre] = useState('');
    const [observacion, setObservacion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [erroresFormulario, setErroresFormulario] = useState({});
    const overlayJustifacion = useRef(null);
    const [tipoActualizacion, setTipoActualizacion] = useState('visibles');
    const [estadoMatriz, setEstadoMatriz] = useState(null);
    const { getRol } = useToken();
    const menuRef = useRef(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [transacciones, setTransacciones] = useState([]);
    const [dialogVerTransacciones, setDialogVerTransacciones] = useState(false);
    const [dialogFechaReporte, setDialogFechaReporte] = useState(false);
    const [tipoReporte, setTipoReporte] = useState('');
    const [clienteIdReporte, setClienteIdReporte] = useState(null);
    const [fechaInicioSeleccionada, setFechaInicioSeleccionada] = useState(null);
    const [fechaFinSeleccionada, setFechaFinSeleccionada] = useState(null);
    const [diasMaxDescargaReporte, setDiasMaxDescargaReporte] = useState(31);
    const [maximo, setMaximo] = useState(null);
    const [verGrafica, setVerGrafica] = useState(false);
    const { table: transaccionTable, lazyParams: lazyParamsTransaccion, setLazyParams: setLazyParamsTransaccion, loading: loadingTransaccion, setLoading: setLoadingTransaccion, setTotalRecords: setTotalRecordsTransaccion, totalRecords: totalRecordsTransaccion, } = InputComponent({ registers: transacciones.transacciones, omodel: transaccionModel, generic, id: transacciones?.cliente_id, });
    const [catalogos, setCatalogos] = useState({});
    const [catalogoCargado, setCatalogoCargado] = useState(false);
    const [comentarioEnEdicion, setComentarioEnEdicion] = useState(null);
    const { refrescarAlertas } = useAlertas();
    const { justificaciones, instrumentosPago, nivelesRiesgo, nivelesAlerta, nivelesSupera } = useContext(TransaccionalContext);

    const justificacionOptions = useMemo(() => justificaciones.map(j => ({ label: j.nombre, value: j.cat_id })), [justificaciones]);
    const tiposDePagoOptions = useMemo(() => instrumentosPago.map(p => ({ label: p.nombre, value: p.cat_id })), [instrumentosPago]);
    const nivelesDeRiesgoOptions = useMemo(() => nivelesRiesgo.map(r => ({ label: r.nombre, value: r.sigla, back_color: r.color_bg })), [nivelesRiesgo]);
    const nivelesDeAlertaOptions = useMemo(() => nivelesAlerta.map(a => ({ label: a.nombre, value: a.sigla, back_color: a.color_bg })), [nivelesAlerta]);
    const nivelesSuperaOptions = useMemo(() => nivelesSupera.map(a => ({ label: a.nombre, value: a.sigla, back_color: a.color_bg })), [nivelesSupera]);

    const misCatalogos = {
        riesgos: nivelesDeRiesgoOptions,
        alertas: nivelesDeAlertaOptions,
        supera: nivelesSuperaOptions,
        justificaciones: justificacionOptions,
        tiposMedioPago: tiposDePagoOptions,
    }

    const ESTADOS = {
        BORRADOR: 'BORRADOR',
        ENVIADO: 'ENVIADO',
        FINALIZADO: 'FINALIZADO'
    };

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    useEffect(() => {
        if (dialogVerTransacciones) {
            loadLazyTransacciones();
        }
        // eslint-disable-next-line
    }, [lazyParamsTransaccion, dialogVerTransacciones]);


    const loadLazyData = () => {
        const params = {
            ...tablaEstado.lazyParams,
            matrizId: matriz.id
        };
        const rol = getRol();
        if (rol) {
            params.rol = rol;
        }
        const endpoint = tablaTemporal ? 'monitoreo/transaccional/listado-temporal' : 'monitoreo/transaccional/listado-matriz';
        tablaEstado.setLoading(true);
        monitoreoService.listado(endpoint, { lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            // Debemos inyectar el estado a la fila, lo que afecta al render debe vivir en la fila
            const registros = res.data.registros.map(row => ({ ...row, _estadoMatriz: res.data.estado_matriz }));
            tablaEstado.setData(registros);
            setEstadoMatriz(res.data.estado_matriz ?? null);
            if (res.data.dias_max_descarga_reporte !== undefined) {
                setDiasMaxDescargaReporte(res.data.dias_max_descarga_reporte);
            }
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingToolbar(false);
            tablaEstado.setLoading(false);
        });
    }

    const handleGuardarMatriz = () => {
        setShowDialog(true);
    };

    const guardarMatriz = () => {
        setLoadingFormulario(true);
        const errores = {};
        if (!nombre.trim()) { errores.nombre = ['El nombre es obligatorio']; }
        if (!codigo.trim()) { errores.codigo = ['El código es obligatorio']; }

        if (Object.keys(errores).length > 0) { setErroresFormulario(errores); setLoadingFormulario(false); return; }

        monitoreoService.nuevo({ nombre, observacion, matrizId: matriz.id, codigo }, 'monitoreo/transaccional/nuevo').then(response => {
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: response.message, life: 3000 });
            handleCloseTabla(true);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingFormulario(false);
        });
    };

    const dialogFormularioHeader = (
        <div className="flex align-items-center justify-content-between w-full px-3 py-2">
            <div className="flex align-items-center gap-2">
                <i className="pi pi-folder-open text-2xl"></i>
                <div>
                    <div className="text-xl font-bold">Nuevo Monitoreo</div>
                    <small className="text-sm">Completa los siguientes datos para guardar el monitoreo</small>
                </div>
            </div>
            <Button icon="pi pi-times" aria-label="Cerrar" className="dialog-boton-cerrar" onClick={() => setShowDialog(false)} rounded />
        </div>
    );

    const nombreBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-between" style={{ width: '100%', gap: '0.5rem' }}>
                <span style={{ flex: '1 1 auto', whiteSpace: 'normal' }}>
                    {rowData.nombres}
                </span>
                {!tablaTemporal && (
                    <Button icon="pi pi-caret-down" className="p-button-rounded p-button-success p-button-icon-only" title="Opciones/Acciones"
                        onClick={(event) => { setSelectedRowData(rowData); menuRef.current.toggle(event); setMaximo(rowData.maximo) }}
                        style={{ flexShrink: 0, width: '2.2rem', height: '2.2rem', minWidth: '2.2rem', }} loading={loadingTransaccion}
                    />
                )}
            </div>
        );
    };

    const justificacionBody = (rowData) => {
        const valorActual = rowData.justifica_alerta_id ?? '';
        const opcionesJustificacionSinNull = justificacionOptions.filter(opt => opt.value !== -1);
        return (<Dropdown value={valorActual} options={opcionesJustificacionSinNull} onChange={(e) => handleSeleccionChange(e.value, rowData)} placeholder="Seleccione" optionLabel="label" optionValue="value" style={{ width: '130px' }} disabled={estadoMatriz === ESTADOS.FINALIZADO} />);
    };

    const comentarioBodyTemplate = (rowData) => {
        const estaGuardando = comentarioEnEdicion === rowData.id;

        return (
            <div style={{ position: 'relative', minHeight: '40px' }}>
                {estaGuardando && (
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 1 }}>
                        <ProgressSpinner style={{ width: '24px', height: '24px' }} strokeWidth="5" />
                        <span style={{ marginLeft: '8px', fontSize: '0.9rem', color: '#666' }}>
                            Guardando...
                        </span>
                    </div>
                )}
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxWidth: '100%', opacity: estaGuardando ? 0.5 : 1 }}>
                    {rowData.comentario}
                </div>
            </div>
        );
    };

    const onRowEditComplete = (e) => {
        let { newData, data } = e;
        if (newData.comentario === data.comentario) {
            return;
        }
        const datos = { id: newData.id, matrizId: matriz?.id, comentario: newData.comentario };
        setComentarioEnEdicion(newData.id);
        actualizarComentario(datos).then((res) => {
            tablaEstado.setData(prevData => {
                return prevData.map(item =>
                    item.id === newData.id ? { ...item, ...newData } : item
                );
            });
            if (toast.current) {
                toast.current.show({ severity: 'success', summary: 'Actualizado', detail: 'Comentario guardado correctamente.', life: 3000 });
            }
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setComentarioEnEdicion(null);
        });
    };

    const finalizarMonitoreo = () => {
        setLoadingToolbar(true);
        monitoreoService.editar({ matrizId: matriz?.id, estado: ESTADOS.FINALIZADO }, 'monitoreo/transaccional/cambiar-estados').then((res) => {
            toast.current.show({ severity: 'success', summary: 'Finalizado', detail: 'El monitoreo fue finalizado exitosamente', life: 3000 });
            setEstadoMatriz(ESTADOS.FINALIZADO);
            tablaEstado.refreshRows(); // Para forzar el re render de filas
            refrescarAlertas();
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingToolbar(false);
        });
    };

    const volverABorrador = () => {
        setLoadingToolbar(true);
        monitoreoService.editar({ matrizId: matriz?.id, estado: ESTADOS.BORRADOR }, 'monitoreo/transaccional/cambiar-estados').then((res) => {
            toast.current.show({ severity: 'success', summary: 'Estado cambiado', detail: 'La matriz volvió al estado BORRADOR', life: 3000 });
            setEstadoMatriz(ESTADOS.BORRADOR);
            tablaEstado.refreshRows(); // Para forzar el re render de filas
            refrescarAlertas();
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadingToolbar(false);
        });
    };

    const handleSeleccionChange = (nuevoValor, rowData) => {

        // Actualización optimista
        tablaEstado.setData(prevData => {
            return prevData.map(item =>
                item.id === rowData.id
                    ? { ...item, justifica_alerta_id: nuevoValor }
                    : item
            );
        });

        const data = {
            tipo: 'individual',
            matrizId: matriz?.id,
            ids: [rowData.id],
            justifica_alerta_id: nuevoValor
        };

        actualizarJustificacion(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Editado', detail: `Justificación actualizada correctamente para ${rowData.nombres}.`, life: 3000 });
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
            // Si la API falla, el dropdown debería volver al valor anterior para no engañar al usuario.
            tablaEstado.setData(prevData => prevData.map(item =>
                item.id === rowData.id
                    ? { ...item, justifica_alerta_id: rowData.justifica_alerta_id }
                    : item
            ));

        });
    };

    const handleFinalizarMonitoreo = () => {
        // Esto valida solo los registros visibles en la página actual
        const incompletos = tablaEstado.data.filter(r => !r.justifica_alerta_id);

        if (incompletos.length > 0) {
            toast.current.show({ severity: 'warn', summary: 'Campos incompletos', detail: 'Faltan justificaciones por seleccionar.', life: 5000 });
            return;
        }

        confirmDialog({
            group: 'finalizar-monitoreo',
            message: {
                texto: '¿Está seguro de finalizar el monitoreo? Esta acción no podrá deshacerse.',
            },
            header: 'Confirmar Finalización',
            icon: 'pi pi-exclamation-triangle'
        });
    };

    const handleVolverABorrador = () => {
        confirmDialog({
            group: 'volver-a-borrador',
            header: '¿Volver a Borrador?',
            message: {
                texto: '¿Estás seguro que deseas volver la matriz al estado BORRADOR?'
            }
        });
    };

    const handleBulkChange = (nuevoValor, tipoActualizacion) => {
        // Actualiza localmente todos los registros
        const datosAnteriores = tablaEstado.data;

        // Actualizamos localmente todos los registros visibles en la tabla
        tablaEstado.setData(prevData => {
            return prevData.map(item => ({
                ...item,
                justifica_alerta_id: nuevoValor
            }));
        });

        const data = {
            tipo: tipoActualizacion,
            matrizId: matriz?.id
        };

        if (tipoActualizacion === 'visibles') {
            data.ids = datosAnteriores.map(item => item.id);
            data.justifica_alerta_id = nuevoValor;
        } else {
            data.justifica_alerta_id = nuevoValor;
            // Por si a futuro enviamos un filtro con la actualización global
        }

        actualizarJustificacion(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Actualización Masiva', detail: 'Justificaciones actualizadas correctamente.', life: 3000 });
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
            tablaEstado.setData(datosAnteriores);
        });
    };

    const actualizarJustificacion = (datosArray) => {
        return monitoreoService.editar(datosArray, 'monitoreo/transaccional/actualizar-justificacion').then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    };

    const actualizarComentario = (data) => {
        return monitoreoService.editar(data, 'monitoreo/transaccional/actualizar-comentario');
    };

    const confirmarBulkChange = (label, nuevoValor, tipoActualizacion) => {
        const cantidadVisibles = tablaEstado.data?.length || 0;
        const mensaje =
            tipoActualizacion === 'visibles'
                ? (
                    <span>
                        ¿Aplicar la justificación <strong>{label}</strong> a <strong>TODOS LOS REGISTROS VISIBLES ({cantidadVisibles})</strong>?
                    </span>
                )
                : (
                    <span>
                        Esta acción actualizará <strong>TODOS LOS REGISTROS</strong> del sistema, visibles o no.
                        <br />
                        ¿Desea aplicar la justificación <strong>{label}</strong> a <strong>TODOS?</strong>
                    </span>
                );
        confirmDialog({
            group: 'justificacion-bulk',
            header: 'Confirmar Cambio',
            message: { texto: mensaje, valores: nuevoValor, tipoActualizacion: tipoActualizacion, },
            defaultFocus: 'accept',
        });
    };

    const valueCell = (data, rowspan, value, color = null) => {
        const res = { text: value };
        if (data === false) {
            res.text = '';
        } else if (data && rowspan) {
            res.rowSpan = rowspan;
            //res.style = 'th';
        }

        if (color) res.fillColor = '#' + color;

        return res;
    }

    const generarDetalle = (detalles, info) => {
        const body = [];

        body.push([
            { text: 'Nombre', style: 'th' },
            { text: 'Identificación', style: 'th' },
            { text: 'Ingreso Mensual Neto', style: 'th' },
            { text: 'Total transaccionado', style: 'th' },
            { text: 'Umbral mínimo parametrizado', style: 'th' },
            { text: 'Q1', style: 'th' },
            { text: 'Mediana', style: 'th' },
            { text: 'Q3', style: 'th' },
            { text: 'Máximo', style: 'th' },
            { text: 'Riesgo por Desviación de Perfil Económico', style: 'th' },
            { text: 'Alerta Temprana', style: 'th' },
            { text: 'Número de Transacciones', style: 'th' },
            { text: 'Alerta por Número de Transacciones', style: 'th' },
            { text: 'Umbral de Transacción', style: 'th' },
            { text: 'Transacciones Superan el Umbral', style: 'th' },
            { text: 'Medio de Pago', style: 'th' },
            { text: 'Valor del Medio de Pago', style: 'th' },
            { text: 'Alerta por medio de pago', style: 'th' },
            { text: 'Fecha de proceso', style: 'th' },
            { text: 'Nivel de Mayor Alerta', style: 'th' },
            { text: 'Justificación', style: 'th' },
            { text: 'Comentario', style: 'th' }
        ]);

        detalles.forEach(row => {
            body.push([
                row.nombres,
                row.identificacion,
                row.ingreso_mensual_neto,
                row.total_transaccion,
                row.inversion,
                row.q1,
                row.mediana,
                row.q3,
                row.maximo,
                valueCell(true, null, row.color_nivel_nombre, row.color_nivel_color),
                valueCell(true, null, row.alerta_temprana_nombre, row.alerta_temprana_color),
                row.numero_transacciones,
                valueCell(true, null, row.alerta_nombre, row.alerta_color),
                row.menor_inversion_esperada, // Umbral de transacción
                valueCell(true, null, row.alerta_menor_5000_nombre, row.alerta_menor_5000_color),
                row.tipo_instrumento,
                row.tipo_instrumento_valor,
                valueCell(true, null, row.alerta_medio_pago_nombre ?? '', row.alerta_medio_pago_color ?? ''),
                row.fecha,
                valueCell(true, null, row.nivel_mayor_alerta_nombre ?? '', row.nivel_mayor_alerta_color ?? ''),
                row.justificacion || '-',
                row.comentario || '-'
            ]);
        });

        const docDefinition = omodel.template(body, info);
        pdfMake.createPdf(docDefinition).download('Reporte_Monitoreo_Transaccional.pdf');
    };

    const generarDetalleTransaccion = (detalles, info) => {
        const body = [];
        let contador = 1;

        // Existe un valor para el reporte?
        const incluirTipoProducto = detalles.some(t => t.tipo_producto);
        const incluirValor1 = detalles.some(t => t.valor1);
        const incluirValor2 = detalles.some(t => t.valor2);
        detalles.forEach(transaccion => {
            const fila = [
                contador++,
                transaccion.cliente,
                transaccion.empresa,
                transaccion.identificacion,
                transaccion.tipo_instrumento,
                transaccion.codigo,
                transaccion.valor,
            ];
            if (incluirValor1) fila.push(transaccion.valor1 || '-');
            if (incluirValor2) fila.push(transaccion.valor2 || '-');
            if (incluirTipoProducto) fila.push(transaccion.tipo_producto || '-');
            fila.push(
                transaccion.detalle,
                transaccion.pais,
                transaccion.provincia || '-',
                transaccion.ciudad,
                transaccion.fecha_transaccion,
                transaccion.fecha_registro
            );
            body.push(fila);
        });
        const docDefinition = transaccionModel.template(body, info, { incluirValor1, incluirValor2, incluirTipoProducto });
        pdfMake.createPdf(docDefinition).download('Listado_transacciones.pdf');
    };

    const exportarIndividual = (tipo, clienteIdReporte, fechaInicioReporte, fechaFinReporte) => {
        setLoadPdf(tipo === 'pdf');
        setLoadExcel(tipo === 'xlsx');
        if (tipo === 'xlsx') {
            monitoreoService.generarDocumento(`monitoreo/transaccion/reporte/${tipo}`, { rol: getRol(), fecha_inicio: fechaInicioReporte, fecha_fin: fechaFinReporte, cliente_id: clienteIdReporte }).then(res => {
                generic.downloadPdf(res.data, 'Listado_transacciones.xlsx');
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        } else {
            monitoreoService.consultarInfo(`monitoreo/transaccion/reporte/${tipo}`, { rol: getRol(), fecha_inicio: fechaInicioReporte, fecha_fin: fechaFinReporte, cliente_id: clienteIdReporte }).then(res => {
                generarDetalleTransaccion(res.data.detalle, res.data.info);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        }
    };

    const exportar = (tipo) => {
        setLoadExcel(tipo === 'xlsx');
        setLoadPdf(tipo === 'pdf');
        if (tipo === 'xlsx') {
            monitoreoService.generar('monitoreo/transaccional/reporte', tipo, matriz?.id).then(res => {
                generic.downloadPdf(res.data, 'Reporte_Monitoreo_Transaccional.' + tipo);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadExcel(false);
                setLoadPdf(false);
            });
        } else {
            monitoreoService.consultar(matriz?.id, `monitoreo/transaccional/reporte/${tipo}`).then(res => {
                generarDetalle(res.data.detalle, res.data.info);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadExcel(false);
                setLoadPdf(false);
            });
        }
    }

    const leftTool = () => {
        return (
            <>
                <Button icon="pi pi-arrow-left" tooltip="Regresar" tooltipOptions={{ position: 'top' }} className="p-button-primary" onClick={() => handleCloseTabla(true)} />
                {estadoMatriz !== null && estadoMatriz !== ESTADOS.FINALIZADO && (
                    <>
                        <Tooltip target=".btn-justificacion" content="Actualizar: Justificación" position="top" />
                        <Button icon="pi pi-file-import" className="btn-justificacion ml-2" severity="help" rounded onClick={(e) => overlayJustifacion.current.toggle(e)} raised />
                    </>
                )}
            </>
        );
    }

    const rightTool = () => {
        return (
            <>
                <div className="flex gap-2">
                    {!tablaTemporal && (
                        <div className="flex gap-2">
                            <Button onClick={() => exportar('pdf')} className="p-button-danger" tooltip="Descargar Reporte PDF" tooltipOptions={{ position: 'top' }} icon="pi pi-file-pdf" loading={loadPdf} disabled={loadExcel} raised />
                            <Button onClick={() => exportar('xlsx')} className="p-button-success" tooltip="Descargar Reporte Excel" tooltipOptions={{ position: 'top' }} icon="pi pi-file-excel" loading={loadExcel} disabled={loadPdf} raised />
                        </div>
                    )}
                    {tablaTemporal && (
                        <Button icon="pi pi-save" label="Guardar Monitoreo" className="p-button-help" onClick={handleGuardarMatriz} tooltip="Guardar monitoreo" tooltipOptions={{ position: 'bottom' }} rounded raised />
                    )}
                    {permss?.actualizar && estadoMatriz === ESTADOS.BORRADOR && siOpcion("monitoreo-transaccional-boton-finalizar") && (
                        <Button onClick={handleFinalizarMonitoreo} className="p-button-info" title="Finalizar Monitoreo" icon="pi pi-check" disabled={loadExcel || loadPdf} label="FINALIZAR MATRIZ" />
                    )}
                    {permss?.actualizar && estadoMatriz === ESTADOS.FINALIZADO && siOpcion("monitoreo-transaccional-boton-borrador") && (
                        <Button onClick={handleVolverABorrador} className="p-button-secondary" title="Volver a Borrador" icon="pi pi-refresh" disabled={loadExcel || loadPdf} label="VOLVER A BORRADOR" />
                    )}
                </div>
            </>

        )
    }

    const loadLazyTransacciones = () => {
        if (!selectedRowData?.cliente_id || !matriz?.fecha_inicio || !matriz?.fecha_fin) return;

        let _lazyParams = lazyParamsTransaccion;
        delete _lazyParams.rtipo;
        if (!catalogoCargado) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }

        const data = {
            cliente_id: selectedRowData.cliente_id,
            fecha_inicio: matriz.fecha_inicio,
            fecha_fin: matriz.fecha_fin,
            lazyEvent: JSON.stringify(_lazyParams)
        };
        setLoadingTransaccion(true);
        monitoreoService.consultarInfo('monitoreo/transaccion/transacciones-cliente-periodo', data).then(res => {
            const transacciones = res?.data?.transacciones;
            if (res.data.instrumento_pago) {
                setCatalogos(prev => ({ ...prev, instrumento_pago: res.data.instrumento_pago.map(p => ({ label: p.nombre, value: p.cat_id })) }));
                setCatalogoCargado(true);
            }
            if (res.data.catalogo_empresas) {
                setCatalogos(prev => ({ ...prev, catalogo_empresas: res.data.catalogo_empresas.map(e => ({ label: e.razon_social, value: e.emp_id })) }));
            }
            const detalle = transacciones.registros;
            const transaccionDetalle = {
                cliente_id: detalle[0]?.cliente_id,
                nombres: detalle[0]?.nombres,
                identificacion: detalle[0]?.identificacion,
                transacciones: detalle
            };
            setTransacciones(transaccionDetalle);
            setTotalRecordsTransaccion(transacciones.total);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => setLoadingTransaccion(false));
    };

    const siOpcion = (key) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(key));
    };

    const handleCerrarDialogTransacciones = () => {
        setDialogVerTransacciones(false);
        setTransacciones({ cliente_id: '', nombres: '', identificacion: '', transacciones: [] });
        setTotalRecordsTransaccion(0);
    };

    const menuItems = () => [
        {
            label: 'Opciones',
            items: [
                {
                    label: 'Ver transacciones',
                    icon: 'pi pi-eye',
                    command: () => setDialogVerTransacciones(true)
                },
                {
                    label: 'Descargar reporte pdf',
                    icon: 'pi pi-file-pdf',
                    command: () => {
                        setTipoReporte('pdf');
                        setClienteIdReporte(selectedRowData?.cliente_id);
                        setDialogFechaReporte(true);
                    }
                },
                {
                    label: 'Descargar reporte excel',
                    icon: 'pi pi-file-excel',
                    command: () => {
                        setTipoReporte('xlsx');
                        setClienteIdReporte(selectedRowData?.cliente_id);
                        setDialogFechaReporte(true);
                    }
                }
            ]
        }
    ];

    const headerChartTemplate = () => {
        return (
            <div className="flex align-items-center gap-2 font-semibold text-lg">
                <i className="pi pi-chart-bar text-xl"></i>
                <span>Transacciones:</span>
                <span>{transacciones?.nombres ?? ''} - {transacciones?.identificacion ?? ''}</span>
                <br />
                <div className="flex align-items-center gap-2 ml-3">
                    <span className="font-medium">Vista:</span>
                    <ToggleButton onLabel="Gráfica" offLabel="Tabla" onIcon="pi pi-chart-bar" offIcon="pi pi-table" checked={verGrafica} onChange={(e) => setVerGrafica(e.value)} className={verGrafica ? 'toggle-grafica' : 'toggle-tabla'} />
                </div>
            </div>
        );
    };

    const cuerpoTemplates = {
        'nombreConAcciones': nombreBodyTemplate,
        'justificacionBody': justificacionBody,
        'comentarioBody': comentarioBodyTemplate
    };

    // Debe ser un array para que se renderice, caso contrario no lo hace
    const columnasDeGestion = !tablaTemporal && estadoMatriz !== ESTADOS.FINALIZADO ? [
        <Column key="rowEditor" rowEditor headerStyle={{ width: '10rem' }} bodyStyle={{ textAlign: 'center' }} header="Editar" />
    ] : null;

    return (
        <>
            <Menu model={menuItems()} popup ref={menuRef} />
            <Tooltip target=".tooltip-info-edicion" content={"Haz clic en el lápiz para agregar o editar el comentario / justificación.\nNo olvides pulsar el check (✓) para guardar."} position="left" style={{ maxWidth: '250px' }} />
            <ConfirmDialogPersonalizado group="volver-a-borrador" icon="pi pi-refresh" onAccept={() => volverABorrador()} />
            <ConfirmDialogPersonalizado group="finalizar-monitoreo" icon="pi pi-exclamation-triangle" onAccept={() => finalizarMonitoreo()} />
            <ConfirmDialogPersonalizado group="justificacion-bulk" icon="pi pi-pen-to-square" onAccept={(message) => handleBulkChange(message.message.valores, message.message.tipoActualizacion)} />
            <Dialog header={dialogFormularioHeader} closable={false} className="dialog-personalizado" visible={showDialog} style={{ width: '30vw' }} onHide={() => setShowDialog(false)} >
                <div className="p-fluid dialog-formulario">
                    <div className="p-field" style={{ marginBottom: '1.5rem' }}>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-book"> </InputIcon>
                            <InputText id="nombre" value={nombre} onChange={(e) => { setNombre(e.target.value); setErroresFormulario(prev => ({ ...prev, nombre: null })); }}
                                placeholder="Nombre del monitoreo" className={erroresFormulario.nombre ? 'p-invalid' : ''} required autoFocus />
                        </IconField>
                        {erroresFormulario.nombre && <small className="p-error">{erroresFormulario.nombre[0]}</small>}
                    </div>

                    <div className="p-field" style={{ marginBottom: '2rem' }}>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-id-card"> </InputIcon>
                            <InputText id="codigo" value={codigo} onChange={(e) => { setCodigo(e.target.value); setErroresFormulario(prev => ({ ...prev, codigo: null })); }}
                                placeholder="Código" className={erroresFormulario.codigo ? 'p-invalid' : ''} required />
                        </IconField>
                        {erroresFormulario.codigo && (<small className="p-error">{erroresFormulario.codigo[0]}</small>)}
                    </div>

                    <div className="p-field" style={{ marginBottom: '1.5rem', marginTop: '2rem' }}>
                        <FloatLabel>
                            <InputTextarea id="observacion" value={observacion} onChange={(e) => { setObservacion(e.target.value); setErroresFormulario(prev => ({ ...prev, observacion: null })); }}
                                rows={3} autoResize className={erroresFormulario.observacion ? 'p-invalid' : ''} />
                            <label htmlFor="observacion">Observación</label>
                        </FloatLabel>
                        {erroresFormulario.observacion && <small className="p-error">{erroresFormulario.observacion[0]}</small>}
                    </div>

                    <div className="p-dialog-footer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-secondary" onClick={() => setShowDialog(false)} />
                        <Button label="Guardar" icon="pi pi-check" className="p-button-primary" onClick={guardarMatriz} loading={loadingFormulario} />
                    </div>
                </div>
            </Dialog>
            <Dialog header={headerChartTemplate(transacciones)} visible={dialogVerTransacciones} onHide={() => handleCerrarDialogTransacciones()} className="dialog-personalizado" modal style={{ width: '850px', height: '850px' }} >
                <div className="p-fluid">
                    {verGrafica ? (
                        <>
                            <ChartPersonalizado datos={transacciones.transacciones} nombreCliente={transacciones.nombres} textoDatos="Transacciones" maximo={maximo}
                                descripcionExtra={`Transacciones del cliente registradas entre el ${matriz.fecha_inicio} y el ${matriz.fecha_fin}.`} nivelesAlerta={nivelesAlerta}
                                tooltipCallback={(context) => {
                                    const transaccion = context.dataset.tooltipDatos?.[context.dataIndex];
                                    return [
                                        `Detalle: ${transaccion.detalle}`,
                                        `Valor: $${transaccion.valor}`,
                                        `Tipo: ${transaccion.tipo_instrumento}`,
                                        `Fecha: ${transaccion.fecha}`,
                                        `País: ${transaccion.pais ?? 'Desconocido'}`,
                                        ...(transaccion.provincia ? [
                                            `Provincia: ${transaccion.provincia}`,
                                            `Ciudad: ${transaccion.ciudad}`
                                        ] : [
                                            `Ciudad: ${transaccion.ciudad_texto}`
                                        ])
                                    ];
                                }}
                            />
                            <Paginator first={lazyParamsTransaccion.first} rows={parseInt(process.env.REACT_APP_ROWS_NUM)} totalRecords={totalRecordsTransaccion}
                                onPageChange={(e) => { setLazyParamsTransaccion((prev) => ({ ...prev, first: e.first, rows: e.rows, page: Math.floor(e.first / e.rows) + 1, })); }} className="mb-4"
                            />
                        </>
                    ) : (
                        transaccionTable({ catalogos })
                    )}
                </div>
            </Dialog>
            {matriz && (
                <Card className="mb-4 pl-4 pt-0 shadow-2 border-round-2xl" style={{ height: '100%', backgroundColor: '#ffffff', borderLeft: '6px solid #30363c', }} >
                    <div className="flex justify-between items-center flex-wrap gap-5">
                        <div>
                            <h3 style={{ margin: 0, color: '#003366', fontFamily: 'Segoe UI, sans-serif' }}>
                                {matriz.nombre}
                            </h3>
                            <Tag value={matriz.codigo} severity="info" style={{ backgroundColor: '#f8f9fa', color: '#003366', marginTop: '0.25rem' }} />
                        </div>
                        <div className="flex flex-column text-right">
                            <small style={{ color: '#888' }}>Fecha de inicio</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.fecha_inicio}
                            </span>
                        </div>
                        <div className="flex flex-column text-right">
                            <small style={{ color: '#888' }}>Fecha de fin</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.fecha_fin}
                            </span>
                        </div>
                        <div className="flex flex-column pl-4">
                            <small style={{ color: '#888' }}>Observación</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {matriz.observacion}
                            </span>
                        </div>
                    </div>
                </Card>
            )}
            {loadingToolbar ? (
                <div className="mb-4 p-toolbar p-component" role="toolbar" data-pc-name="toolbar" data-pc-section="root">
                    <div className="p-toolbar-group-start p-toolbar-group-left" data-pc-section="start"></div>
                    <div className="p-toolbar-group-center" data-pc-section="center">
                        <div className="flex justify-content-center">
                            <ProgressSpinner style={{ width: '32.4px', height: '32.4px' }} strokeWidth="5" />
                        </div>
                    </div>
                    <div className="p-toolbar-group-end p-toolbar-group-right" data-pc-section="end"></div>
                </div>
            ) : (
                <Toolbar className="mb-4" start={leftTool} end={rightTool} />
            )}
            <OverlayPanel ref={overlayJustifacion} showCloseIcon style={{ width: '320px' }} dismissable>
                <Card className="p-2">
                    <h5 className="text-center mb-3">Actualización masiva de Justificación</h5>

                    <div className="mb-3">
                        <h6 className="font-medium mb-3 text-center">¿A que registros desea aplicar el cambio?</h6>
                        <div className="flex flex-column gap-3">
                            <div className="flex align-items-center">
                                <RadioButton inputId="visibles" name="tipoActualizacion" value="visibles" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'visibles'} variant="filled" />
                                <label htmlFor="visibles" className="ml-2">Registros visibles</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="todos" name="tipoActualizacion" value="todos" onChange={(e) => setTipoActualizacion(e.value)} checked={tipoActualizacion === 'todos'} variant="filled" />
                                <label htmlFor="todos" className="ml-2">Todos los registros</label>
                            </div>
                        </div>
                    </div>

                    <Divider />

                    <div className="mb-2 font-medium">Seleccionar justificación</div>
                    <Dropdown
                        options={justificacionOptions.filter(o => o.value !== -1)}
                        placeholder="Seleccionar justificación"
                        className="w-full"
                        onChange={e => {
                            const opt = justificacionOptions.find(o => o.value === e.value);
                            confirmarBulkChange(opt.label, e.value, tipoActualizacion);
                            overlayJustifacion.current.hide();
                        }}
                    />
                </Card>
            </OverlayPanel>
            {/* Tabla */}
            <TablaDinamica modelo={TablaTransaccionModel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" catalogos={misCatalogos} cuerpoTemplates={cuerpoTemplates} acciones={columnasDeGestion} editMode="row" onRowEditComplete={onRowEditComplete} />
            <Dialog visible={dialogFechaReporte} header="Seleccionar rango de fechas para el reporte" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogFechaReporte(false)} style={{ maxWidth: '500px' }}>
                <form onSubmit={(e) => { e.preventDefault(); if (!fechaInicioSeleccionada || !fechaFinSeleccionada) { toast.current.show({ severity: 'warn', summary: 'Faltan fechas', detail: 'Seleccione fecha inicio y fin' }); return; } exportarIndividual(tipoReporte, clienteIdReporte, fechaInicioSeleccionada, fechaFinSeleccionada); setDialogFechaReporte(false); }}>
                    <div className="formgrid grid">
                        <div className="field col-6">
                            <label>Fecha Inicio *</label>
                            <Calendar value={fechaInicioSeleccionada} onChange={(e) => setFechaInicioSeleccionada(e.value)} dateFormat="yy-mm-dd" showIcon maxDate={new Date()} readOnlyInput />
                        </div>
                        <div className="field col-6">
                            <label>Fecha Fin *</label>
                            <Calendar value={fechaFinSeleccionada} onChange={(e) => setFechaFinSeleccionada(e.value)} dateFormat="yy-mm-dd" showIcon maxDate={new Date()} readOnlyInput />
                        </div>
                    </div>
                    <div className="p-d-flex p-jc-end p-mt-3">
                        <Button label="Aceptar" type="submit" className="p-ml-2" />
                    </div>
                    <span style={{ color: 'red', fontSize: '9px', fontWeight: 'bold' }}>*El rango máximo permitido para el reporte es de {diasMaxDescargaReporte} días</span>
                </form>
            </Dialog>
        </>
    )
}
